
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcModalWindow as ObcModalWindowElement} from '@oicl/openbridge-webcomponents/dist/components/modal-window/modal-window.js';
 
 
 

 
 export const ObcModalWindow = createComponent({
   react: React,
   tagName: 'obc-modal-window',
   elementClass: ObcModalWindowElement,
   events: {
     
     onCloseClick: 'close-click' as EventName<CustomEvent<unknown>>,
     onCancelClick: 'cancel-click' as EventName<CustomEvent<unknown>>,
     onDoneClick: 'done-click' as EventName<CustomEvent<unknown>>,
     onOptionClick: 'option-click' as EventName<CustomEvent<unknown>>,
   }
  });
 
 